import { Box, Button } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'center',
  rowGap: theme.spacing(2),
  columnGap: theme.spacing(6),
  width: '100%',
  marginBottom: theme.spacing(6),
  marginTop: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    marginBottom: 0,
    marginTop: 0,
    justifyContent: 'space-evenly',
  },
}));

export const StyledSecondaryButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.customShape.borderRadiusFull,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontSize: theme.typography.pxToRem(16),
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '&:first-letter': {
    textTransform: 'uppercase',
  },
}));

export const StyledPrimaryButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.customShape.borderRadiusFull,
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  fontSize: theme.typography.pxToRem(16),
  '&:hover': {
    borderColor: theme.palette.primary.dark,
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.action.hover,
  },
  '&:first-letter': {
    textTransform: 'uppercase',
  },
}));
